import { lighten } from '@material-ui/core';
import { themes as lumenThemes } from '@tradener/lumen';

import { lumenTheme } from '~/configuration/theme';
import useColorMode from '~/hooks/useColorMode';
import usePortfolio from '~/pages/Portfolio/usePortfolio';
import { grey } from '~/theme';
import getPeriodTime from '~/utils/getPeriodTime';

const usePeriodComparison = () => {
  const { colorTernary, mode } = useColorMode();
  const { expandedPeriods } = usePortfolio();

  return (period: string) => {
    const color = {
      BEFORE: colorTernary(lighten(grey[800], 0.025), '#F6F6F6'),
      CURRENT: colorTernary(lighten(grey[800], 0.05), '#EEE'),
      AFTER: 'inherit',
    }[getPeriodTime(period)] as string;

    if (!/-/.test(period) && expandedPeriods.includes(period)) {
      const brand = lumenThemes[lumenTheme].modeColors.brand(mode);

      return colorTernary(`${brand['500']}29`, brand['50']);
    }

    return color;
  };
};

export default usePeriodComparison;
